import api from 'api';

// Snapshot returned by the public DMZ endpoint (39196). The axios response interceptor already
// unwraps the `{ result }` envelope, so this resolves to the snapshot object or null (expired/missing).
export interface PreRegistrationTokenSnapshot {
  globalPayeeId: number;
  businessLegalName: string;
  legalAddress: string;
  addressLine2: string;
  city: string;
  stateProvince: string;
  postalCode: string;
  country: string;
  mainBusinessEmail: string;
  mainBusinessPhone: string;
  // Contact person = the logged-in user performing the upgrade; prefills the "Tell us how to contact you" step.
  contactFirstName: string;
  contactLastName: string;
  contactEmail: string;
  contactPhone: string;
}

// The prefill key is always a GUID. Validating it before it reaches a request URL (or gates the
// prefill branch) keeps user-controlled input from altering the request target or bypassing a
// security-relevant path — CWE-918 (request forgery) / CWE-807 (user-controlled bypass).
const TOKEN_KEY_PATTERN =
  /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;

export const isPreRegistrationKey = (key?: string | null): boolean =>
  !!key && TOKEN_KEY_PATTERN.test(key);

export const getPreRegistrationToken = async (
  key: string,
): Promise<PreRegistrationTokenSnapshot | null> => {
  // Reject anything that isn't a well-formed GUID so it never reaches the request path.
  if (!isPreRegistrationKey(key)) {
    return null;
  }

  const result: PreRegistrationTokenSnapshot | null = await api.get(
    `PreRegistrationTokens/${encodeURIComponent(key)}`,
  );

  return result;
};

export default { getPreRegistrationToken, isPreRegistrationKey };
